// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"2ab1a6d7","453":"44b66971","732":"9f0c686d"}[chunkId] + ".chunk.js";
};